import React, { useState } from "react";
import { Modal, Button } from "antd";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import { CloseOutlined } from "@ant-design/icons";

const CommonModal = ({
  title,
  icon,
  content,
  isVisible,
  onClose,
  onConfirm,
  width,
  noFooter,
  footerComp,
}) => {
  // console.log(icon);

  return (
    <Modal
      title={
        <div className="flex items-center bg-gray-200 p-2.5 rounded-md">
          {icon &&
            React.createElement(icon, { className: "text-[16px] text-black" })}
          <span className="capitalize text-[.910rem] text-black  ml-2">
            {title}
          </span>
        </div>
      }
      open={isVisible}
      onCancel={onClose}
      onOk={onConfirm}
      closable={false}
      destroyOnClose
      footer={
        noFooter
          ? []
          : footerComp
          ? footerComp
          : [
              <div className="flex justify-center mt-4 gap-4">
                {" "}
                {/* Center align */}
                <Button
                  key="submit"
                  type="primary"
                  className="mr-2 w-[104px] h-[30px] font-medium"
                  onClick={onConfirm}
                >
                  <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
                  Apply
                </Button>
                <Button onClick={onClose} className="reset-button">
                  <CloseOutlined className="!text-[14px] font-medium" />
                  Cancel
                </Button>
              </div>,
            ]
      }
      width={width}
      centered
    >
      {content}
    </Modal>
  );
};

export default CommonModal;
